import styled, { css } from 'styled-components';

export const StyledTextInput = styled.input(
  ({ theme, backgroundColor = 'white', isError, disabled, hasIcon }) => css`
    height: ${theme.spacing.xm};
    resize: none;
    overflow: hidden;
    outline: none;
    color: ${theme.colors.eerieBlack};
    border: 1px solid
      ${isError ? theme.colors.redCrayola : theme.colors.platinumDark};
    border-radius: ${theme.radius.s};
    padding: ${theme.spacing.xm} ${theme.spacing.m};
    padding-right: ${hasIcon ? theme.spacing.xl : theme.spacing.m};
    background-color: ${disabled
      ? theme.colors.seasalt
      : theme.colors[backgroundColor]};

    &:focus-within {
      border: 1px solid ${theme.colors.eerieBlack};
      background-color: ${theme.colorsInObjects.gray[200]};
    }
    width: 100%;
    box-sizing: border-box;
  `
);

export const StyledTextInputContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export const StyledTextLabel = styled.div`
  margin-bottom: ${({ theme }) => theme.spacing.s};
`;

export const IconContainer = styled.div`
  position: absolute;
  top: calc(50% - 12px);
  right: ${({ theme }) => theme.spacing.sm};
`;

export const InputContainer = styled.div`
  position: relative;
`;
